import PropTypes from 'prop-types';
import { withHandlers, withProps, compose, setPropTypes } from 'recompose';
import { Checkbox, Radio } from '@nextiva/next-ui';
import { checkableOptionTypes } from '@nextiva/engagement-ui';

const isSingleChoice = type => type === checkableOptionTypes.SINGLE;

export default compose(
  setPropTypes({
    type: PropTypes.oneOf(Object.keys(checkableOptionTypes)),
    input: PropTypes.object,
  }),
  withProps(({ type }) => ({
    InputComponent: isSingleChoice(type) ? Radio : Checkbox,
  })),
  withHandlers({
    isOptionChecked: ({ type, input: { value } }) => option =>
      isSingleChoice(type)
        ? option.id === value.id
        : value.some(item => item.id === option.id),
    getOptionHandler: ({
      type,
      input: { value, onChange },
    }) => option => checked => {
      if (isSingleChoice(type)) {
        onChange(option);
      } else {
        const answer = [...value];
        if (checked) {
          answer.push(option);
        } else {
          answer.splice(answer.findIndex(item => item.id === option.id), 1);
        }
        onChange(answer);
      }
    },
  }),
);
